import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TonnageMessage } from '@classes/tonnage-message';
// import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { EnvConfigurationService } from 'app/core/services/env-configuration.service';

@Injectable({
  providedIn: 'root'
})
export class TonnageMessageService {
  environment = this.envConfigurationService.environment;

  private basePath = this.environment.apiUrl + '/tonnageMessage';

  constructor(
    private http: HttpClient,
    public envConfigurationService: EnvConfigurationService
  ) { }

  getTonnageMessages(tonnageID: string): Observable<Array<TonnageMessage>> {
    return this.http.get<Array<TonnageMessage>>(this.basePath + '/' + tonnageID);
  }

  postTonnageMessage(tonnageMessage: TonnageMessage) {
    return this.http.post<any>(this.basePath,
      tonnageMessage
    ).pipe(map(m => {
      return m
    }));
  }
  removeError(tonnageMessage: TonnageMessage) {
    return this.http.post<any>(this.basePath + '/removeError',
      tonnageMessage
    );
  }
}
